import { render, staticRenderFns } from "./HomeBtn.vue?vue&type=template&id=63e8f13a&scoped=true"
import script from "./HomeBtn.vue?vue&type=script&lang=js"
export * from "./HomeBtn.vue?vue&type=script&lang=js"
import style0 from "./HomeBtn.vue?vue&type=style&index=0&id=63e8f13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8f13a",
  null
  
)

export default component.exports